module.exports = __webpack_public_path__ + "static/media/ic-mute.a2bf7963.webp";